import type { StatusPedido } from './dominio';

// Espelho do trigger pedidos_validar_status (supabase/migrations/*_regras.sql).
// O banco é quem garante; aqui serve para a interface só oferecer o que é possível.
const TRANSICOES: Record<StatusPedido, readonly StatusPedido[]> = {
  pendente: ['a_caminho', 'cancelado'],
  a_caminho: ['entregue', 'nao_entregue', 'pendente'],
  nao_entregue: ['pendente', 'cancelado'],
  entregue: [],
  cancelado: [],
};

export function podeTransitar(de: StatusPedido, para: StatusPedido): boolean {
  return TRANSICOES[de].includes(para);
}

export function proximosStatus(de: StatusPedido): readonly StatusPedido[] {
  return TRANSICOES[de];
}

export function exigeMotivo(para: StatusPedido): boolean {
  return para === 'nao_entregue' || para === 'cancelado';
}

export function statusFinal(status: StatusPedido): boolean {
  return TRANSICOES[status].length === 0;
}

export const ROTULO_STATUS: Record<StatusPedido, string> = {
  pendente: 'Para sair',
  a_caminho: 'A caminho',
  entregue: 'Entregue',
  nao_entregue: 'Não entregue',
  cancelado: 'Cancelado',
};

/** Tom semântico do status. A cor de cada tom vem do tema, nunca da marca. */
export type TomStatus = 'neutro' | 'andamento' | 'sucesso' | 'alerta' | 'erro';

export const TOM_STATUS: Record<StatusPedido, TomStatus> = {
  pendente: 'neutro',
  a_caminho: 'andamento',
  entregue: 'sucesso',
  nao_entregue: 'alerta',
  cancelado: 'erro',
};

// ── Ações do app do entregador ───────────────────────────────────────────────
export const ACOES_ENTREGADOR = ['iniciar', 'entregar', 'nao_entregue', 'desfazer'] as const;
export type AcaoEntregador = (typeof ACOES_ENTREGADOR)[number];

const DESTINO_DA_ACAO: Record<AcaoEntregador, StatusPedido> = {
  iniciar: 'a_caminho',
  entregar: 'entregue',
  nao_entregue: 'nao_entregue',
  desfazer: 'pendente',
};

export function statusAposAcao(acao: AcaoEntregador): StatusPedido {
  return DESTINO_DA_ACAO[acao];
}

export function acoesDisponiveis(status: StatusPedido): AcaoEntregador[] {
  return ACOES_ENTREGADOR.filter((acao) => podeTransitar(status, DESTINO_DA_ACAO[acao]));
}

/** Motivos de um toque do "Não consegui entregar" (o detalhe é opcional). */
export const MOTIVOS_RAPIDOS = [
  'Cliente ausente',
  'Endereço não encontrado',
  'Cliente recusou',
  'Sem troco',
] as const;

/** "Cliente ausente: toquei 3 vezes": o motivo de um toque e o detalhe numa frase só. */
export function juntarMotivo(rapido: string | null, detalhe: string): string {
  const texto = detalhe.trim();
  if (!rapido) return texto;
  return texto ? `${rapido}: ${texto}` : rapido;
}
